function setUnreadNotifications(count) {
	const notificationsSticker = document.querySelector('.notifications-sticker');

	if (count > 0) {
		notificationsSticker.classList.remove('d-none');
		notificationsSticker.textContent = count > 9 ? '9+' : count;
	} else {
		notificationsSticker.classList.add('d-none');
	}
}

window.updateUnreadNotifications = function () {
	window.keycloak.onAuthenticated(() => {
		const winixUrl = document.getElementById('winixUrl').value;

		fetch(`${winixUrl}/opauth/loginbybearer`, {
			credentials: 'include',
			headers: {
				Accept: 'application/json',
				Authorization: window.keycloak.getBearerToken(),
			},
		})
			.then((res) => res.json())
			.then((res) => {
				setUnreadNotifications(res.auth_token.user.unread_notifications);
			});
	});
};

window.updateUnreadNotifications();
